import './Style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { useEffect } from "react";

import MainLayout from "./Layout/MainLayout";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Detailspage from "./Pages/Detailspage";
import Contact from "./Pages/Contact";
import Termsandcondition from "./Component/Terms";
import Privacy from "./Component/Privacy";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppWrapper() {
  const location = useLocation();

  const hideHeaderRoutes = ["/privacy", "/terms", "/contact"];

  const hideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route
          path="/"
          element={<MainLayout hideHeader={hideHeader} />}
        >
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="details-page" element={<Detailspage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="terms" element={<Termsandcondition />} />
          <Route path="privacy" element={<Privacy />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;